class CountdownTimer extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    // Get Active & Current Dates
    let countdownTimer = document.querySelector('.product__countdown-timer');
    let countdownDate = countdownTimer.dataset.cutoffTime;
    let activeDays = countdownTimer.dataset.activeDays;

    activeDays = activeDays
      .split(',')
      .filter((n) => n)
      .map(Number);

    let dayIndex;
    let deliveryDay;

    let date = new Date(countdownDate);
    let dateSeconds = date.getTime();

    let today = new Date();
    today = today.getDay();

    if (new Date().getTime() < dateSeconds) {
      if(today == 6 || today == 0) {
        dayIndex = 2;
      } else {
        dayIndex = today + 1;
      }
    } else {
      if(today == 5 || today == 6 || today == 0) {
        dayIndex = 2;
      } else {
        dayIndex = today + 2;
      }
    }

    activeDay(dayIndex);

    function activeDay(dayIndex) {
      if (activeDays.includes(dayIndex)) {
        getDeliveryDay(dayIndex);
      } else {
        dayIndex = dayIndex + 1;
        if (dayIndex > activeDays.slice(-1)) {
          dayIndex = 0;
        }
        activeDay(dayIndex);
      }
    }

    function getDeliveryDay(dayIndex) {
      deliveryDay = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'][dayIndex];
    }

    // Update & Display Countdown
    const timerText = countdownTimer.innerHTML;

    // Update the count down every 1 second
    let x = setInterval(function () {
      // Get today's date and time
      let now = new Date().getTime();

      date = new Date(countdownDate);
      dateSeconds = date.getTime();

      // Find the distance between now and the count down date
      let distance = dateSeconds - now;

      // Add an extra day if we've already passed the cutoff time
      if (distance < 0) {
        dateSeconds = dateSeconds + 60 * 60 * 24 * 1000;
        distance = dateSeconds - now;        
        activeDay(dayIndex);
      }

      // Time calculations for hours, minutes and seconds
      let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      let seconds = Math.floor((distance % (1000 * 60)) / 1000);

      // Replace string with times
      function dateReplace(text, correction) {
        const reg = new RegExp(Object.keys(correction).join('|'), 'g');
        return text.replace(reg, (matched) => correction[matched]);
      }
      // Consume the function as follows
      const correction = {
        hrs: '<span class="time">' + hours + ' <span>hrs</span></span>',
        mins: '<span class="time">' + minutes + ' <span>mins</span></span>',
        secs: '<span class="time">' + seconds + ' <span>secs</span></span>',
      };

      let correctedText = dateReplace(timerText, correction);

      // Swap out the Day of the Week
      correctedText = correctedText.replace('weekDay', '<span>' + deliveryDay + '</span>');

      countdownTimer.innerHTML = correctedText;

      if (countdownTimer.classList.contains('hidden')) {
        countdownTimer.classList.remove('hidden');
      }

    }, 1000);
  }
}

customElements.define('countdown-timer', CountdownTimer);